import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');

class TemplateCarouselPropertyFirst extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {}
        };
    };

    componentWillMount() {
        let url = window.location.search;
        let data = queryString.parse(url);
        this.setState({
            data: data
        });
    }

    render() {
        return(
            <div className={Styles.container}>
                {
                    <div style={{backgroundImage: 'url('+this.state.data.image+')'}} className={cx(Styles.First)}>
                        <div className={Styles.FirstInnerOverlay}>
                            <div className={Styles.FirstInnerOverlaySlogan}>
                                slogan
                            </div>
                            <div className={Styles.FirstInnerOverlayTitle}>
                                {this.state.data.first_title}
                            </div>
                            <div className={Styles.FirstInnerOverlaySubtitle}>
                                {this.state.data.first_subtitle}
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default TemplateCarouselPropertyFirst;


// WEBPACK FOOTER //
// ./src/templates/carousel/property/first/component.js